import axios from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/apiEndpoints';

export const fetchApplications = async () => {
  try {
    const response = await axios.get(API_ENDPOINTS.applications);
    return response.data;
  } catch (error) {
    console.error('Error fetching applications:', error);
    throw error;
  }
}; 